import Const from 'const';
import {FilterLineupsByKeyPlayerStackCombinationsInterface} from 'src/components/molecules/filter-lineups-by-key-player-stack-combinations/filter-lineups-by-key-player-stack-combinations-interface';
import {ComboUnitInterface} from 'services/key-player-stacking/combo-unit';

class FilterLineupsByKeyPlayerStackCombinations implements FilterLineupsByKeyPlayerStackCombinationsInterface {
    constructor(
        private readonly checkedCombinations: ComboUnitInterface[] = [],
        private readonly lineupIds: string[] = [],
    ) {}
    hasCheckedCombinations(): boolean {
        return !isEmpty(this.checkedCombinations);
    }
    isComboChecked(comboUnit: ComboUnitInterface): boolean {
        for (const checkedCombo of this.checkedCombinations) {
            if (checkedCombo.getUnitId() === comboUnit.getUnitId()) {
                return true;
            }
        }

        return false;
    }
    getCheckedCombinations(): ComboUnitInterface[] {
        return this.checkedCombinations;
    }
    getLineupIds(): string[] {
        return this.lineupIds;
    }
    getLineupsQuantity(): number {
        return this.lineupIds.length;
    }
}

const filterLineupsByKeyPlayerStackCombinations = new FilterLineupsByKeyPlayerStackCombinations();

export default function (state = filterLineupsByKeyPlayerStackCombinations, action) {
    switch (action.type) {
        case Const.FILTER_LINEUPS_BY_KEY_PLAYER_STACK_COMBINATIONS_SET_COMBO:
            const {checkedCombinations, lineupIds} = action.data;

            return new FilterLineupsByKeyPlayerStackCombinations(checkedCombinations, lineupIds);

        case Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER:
        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new FilterLineupsByKeyPlayerStackCombinations();

        default:
            return state;
    }
}
